var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatechallengeEmpvsempDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-user-24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 13C18.568 13 17 14.567 17 16.5C17 18.433 18.568 20 20.5 20C22.432 20 24 18.433 24 16.5C24 14.567 22.432 13 20.5 13ZM22 17H21V18H20V17H19V16H20V15H21V16H22V17ZM8.999 11.1C8.999 12.792 8.233 14 7.793 15H6.396C6.623 14 8.35 11.585 7.417 10.018C6.867 9.095 5.145 9.094 4.598 10.003C4.091 10.844 4.358 12.42 5.31 14.218C5.828 15.196 5.684 15.952 5.472 16.415C5.066 17.304 4.169 17.732 3.156 18.027C1.146 18.615 1.331 18.082 1.331 20H0.002L0 19.382C0 18.12 0.099 17.393 1.59 17.049C3.309 16.652 4.909 16.304 4.135 14.84C1.774 10.383 3.508 8 6.001 8C7.688 8 8.999 9.09 8.999 11.1ZM14.69 12.495C15.297 13.641 15.137 14.511 14.896 15.038C14.236 16.483 12.424 16.901 10.506 17.343C9.254 17.633 9.334 17.931 9.334 20H8.003L8 19.175C8 17.494 8.132 16.523 10.119 16.064C12.412 15.534 14.546 15.07 13.513 13.118C10.366 7.177 12.678 4 16.001 4C19.165 4 21.338 6.879 19.042 12H17.559C18.718 9.675 18.987 7.674 18.267 6.467C17.365 4.95 14.65 4.958 13.755 6.445C12.987 7.718 13.329 9.923 14.69 12.495Z",
    fill: "#67748E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatechallengeEmpvsempDark);
export default __webpack_public_path__ + "static/media/createchallenge-empvsemp-dark.905212f6cb4d99a840ca154f7af4e35c.svg";
export { ForwardRef as ReactComponent };